import { getReadingPaneProjectionDefinitionMLR } from './MLR/readingPaneProjectionDefinitionMLR';
import { getReadingPaneProjectionDefinitionSLR } from './SLR/readingPaneProjectionDefinitionSLR';
import { useWindow } from '@fluentui/react/lib/WindowProvider';
import { observer } from 'mobx-react-lite';
import { CommandRibbon } from 'owa-command-ribbon';
import { MailRibbonTabId } from 'owa-ribbon-ids';
import { getMailIconColorMap } from 'owa-mail-ribbon/lib/util/mailIconColorMap';
import React, { useMemo } from 'react';
import type { ClientItemId } from 'owa-client-ids';

export interface ReadingPaneProjectionRibbonProps {
    itemId: ClientItemId;
}

export default observer(function ReadingPaneProjectionRibbon(
    props: ReadingPaneProjectionRibbonProps
) {
    const targetWindow: Window = useWindow() ?? window;

    const { getSingleLineRibbonDefinition, getMultiLineRibbonDefinition } = useMemo(() => {
        const ribbonProps = {
            showMoveRules: true,
            attachmentPickers: undefined,
            popoutComposeViewState: undefined,
            targetWindow,
            itemId: props.itemId,
        };
        return {
            getSingleLineRibbonDefinition: () => getReadingPaneProjectionDefinitionSLR(ribbonProps),
            getMultiLineRibbonDefinition: () => getReadingPaneProjectionDefinitionMLR(ribbonProps),
        };
    }, [props.itemId]);

    return (
        <span>
            <CommandRibbon
                getSingleLineRibbonDefinition={getSingleLineRibbonDefinition}
                getMultiLineRibbonDefinition={getMultiLineRibbonDefinition}
                getDefaultSelectedTabId={getDefaultSelectedTabId}
                getHideTopRibbon={getHideTopRibbon}
                iconColorMap={getMailIconColorMap()}
                thisWindow={targetWindow}
                isProjectionPopout={true} // ADO135671 - For OWA MSIT Experiment
            />
        </span>
    );
});

function getHideTopRibbon() {
    return true;
}

function getDefaultSelectedTabId() {
    return MailRibbonTabId.Tab_Read;
}
